module.exports = __webpack_public_path__ + "static/media/attrictionPredictor.f28fc9b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/attrictionPredictor.png
// module id = 884
// module chunks = 0